module.exports = __webpack_public_path__ + "fw1.png?809d5d68ed009aab156357dfa464e161";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fw1.png
// module id = 641
// module chunks = 0